/**
 * FuarLogoImg — fuar logosu, yüklenemezse varsayılan görsele düşer (backlog #18/#20).
 *
 * `url` backend'in `fuarLogoUrl`'i (mutlak ya da backend'e göreli), `fileName` ham
 * `fuarLogo` — yalnızca fuarLogoUrl dönmeyen eski bir backend için. Eski PHP sunucusundaki
 * dosya kaybolmuş olabilir; backend bunu satır başına denetlemiyor, o yüzden düşüş burada.
 */
import React, { useState } from "react";
import { fuarLogoSrc, FUAR_LOGO_DEFAULT_SRC } from "../../services/fuarService";

const FuarLogoImg = ({ url, fileName, alt = "", ...imgProps }) => {
    const src = fuarLogoSrc(url, fileName);
    // Hangi src'nin bozulduğunu tut: src değişince düşüş kendiliğinden sıfırlanır, varsayılan
    // görsel de bozulursa aynı değer yeniden yazılır ve döngü olmaz.
    const [failedSrc, setFailedSrc] = useState(null);

    return (
        <img
            {...imgProps}
            src={failedSrc === src ? FUAR_LOGO_DEFAULT_SRC : src}
            alt={alt}
            onError={() => setFailedSrc(src)}
        />
    );
};

export default FuarLogoImg;
